module.exports = __webpack_public_path__ + "static/img/home-icon5.ba496f1f.png";